/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconZodiacCapricorn = createReactComponent("zodiac-capricorn", "IconZodiacCapricorn", [
  ["path", { d: "M4 4a3 3 0 0 1 3 3v9", key: "svg-0" }],
  ["path", { d: "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3", key: "svg-1" }],
  ["path", { d: "M16 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }]
]);

export { IconZodiacCapricorn as default };
//# sourceMappingURL=IconZodiacCapricorn.js.map
